<script lang="ts">
  import Button from "$components/MatomoButton.svelte";
  import Icon from "@brave/leo/src/components/icon/icon.svelte";
  import Input from "@brave/leo/src/components/input/input.svelte";
  import { quintOut } from "svelte/easing";
  import { slide } from "svelte/transition";
  import { m } from "$lib/paraglide/messages";
  import { showError } from "$lib/alerts";

  export let email = "";
  export let onSubmit: (email: string) => Promise<void> = undefined;
  export let buttonText = m.get_login_link_button();
  export let isDisabled = false;
  export let isVertical = false;
  export let eventCategory: string | undefined = undefined;
  export let eventAction: string | undefined = undefined;
  export let eventName: string | undefined = undefined;

  let isLoading = false;

  type LoginErrorType = "INVALID_EMAIL_CASE" | "INVALID_EMAIL";
  let errorType: LoginErrorType | null = null;

  const onInput = () => {
    errorType = null;
  };

  const handleSubmit = async (e: Event) => {
    e.preventDefault();

    if (email.length >= 1000 || !/\S+@\S+\.\S+/.test(email)) {
      errorType = "INVALID_EMAIL";
      return;
    }

    isLoading = true;

    try {
      await onSubmit?.(email);
    } catch (error) {
      console.error(error);

      if (error?.status === 422) {
        errorType = "INVALID_EMAIL_CASE";
      } else if (error?.status >= 400 && error?.status < 500) {
        errorType = "INVALID_EMAIL";
      } else {
        // TODO: should we have some sort of generic copy for this?
        showError({ error });
      }
    }

    isLoading = false;
  };
</script>

<form class="grid w-full items-start gap-xl" class:isVertical novalidate>
  <div style="--leo-control-label-gap: 0">
    <Input
      bind:value={email}
      {onInput}
      showErrors={errorType !== null}
      type="email"
      placeholder={m.email_address_placeholder()}
      mode="outline"
      size="large"
      autofocus
    >
      <div
        slot="errors"
        class="mt-m flex gap-m text-systemfeedback-error-text"
        in:slide={{ duration: 100, easing: quintOut }}
      >
        <Icon name="warning-triangle-outline" />
        {#if errorType === "INVALID_EMAIL_CASE"}
          {m.invalid_email_case_error()}
        {:else}
          {m.valid_email_required_error()}
        {/if}
      </div>
    </Input>
  </div>
  <Button
    onClick={handleSubmit}
    {eventCategory}
    {eventAction}
    {eventName}
    isDisabled={email.length <= 0 || errorType !== null || isDisabled}
    kind="filled"
    size="large"
    type="submit"
    {isLoading}
  >
    {buttonText}
  </Button>
</form>

<style>
  @media screen(md) {
    form:not(.isVertical) {
      grid-template-columns: 1fr max-content;
    }
  }
</style>
